import { useEffect, useState } from 'react';
export function useNodeHeight(childRef, initialHeight = 0, 
/**
 * Whether to disable useNodeHeight hook. This is provided to optimize
 * useless updates when the results are not used due to responsive design, etc
 */
disabled = false) {
    const [height, setHeight] = useState(initialHeight);
    useEffect(() => {
        if (disabled)
            return;
        const childElem = childRef.current;
        if (childElem == null)
            return;
        let timerId = null;
        const update = () => {
            timerId = null;
            const rect = childElem.getBoundingClientRect();
            const newHeight = rect.bottom - rect.top;
            if (newHeight !== height) {
                setHeight(newHeight);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('resize', scheduleUpdate);
        update();
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('resize', scheduleUpdate);
        };
    });
    return height;
}
//# sourceMappingURL=useNodeHeight.js.map